import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { selectUserById, useGetUsersQuery } from '../../store/api/usersApi';

export default function Avatar({ userId }) {
  const { isLoading } = useGetUsersQuery();
  const author = useSelector((state) => selectUserById(state, userId));

  if (isLoading) return <span>Loading...</span>;

  return <img src={author.avatar} alt={author.name} />;
}

Avatar.propTypes = {
  userId: PropTypes.string.isRequired,
};
